const priceData = {
  "/": {
    title:"PRICING PLANS",
    heading: "You Define the Growth,",
    subheading: "We’ll Deliver It.",
  },
  "/pricing": {
    heading: "You Define the Growth",
    subheading: "We’ll Deliver It.",
  },
};
export default priceData;